import { mobileBreakpoint } from '../Utils/Breakpoints';
import { useMediaQuery } from 'react-responsive';

export function Logo(props) {
    const isMobile = useMediaQuery({ query: '(max-width: ' + mobileBreakpoint + 'px)' });

    if (isMobile) {
        return (

            <a href="https://www.compositeurdigital.com" target="_blank" rel="noopener noreferrer">
                <img src="assets/logoCDUXsmall.png" style={{ width: '70vw', maxWidth: 70, height: 'auto' }} alt="Compositeur Digital UX" />
                </a>
        )
    } else {
        return (
            <a href="https://www.compositeurdigital.com" target="_blank" rel="noopener noreferrer">
                <img src="assets/logoCDUX.png" style={{ width: '70vw', maxWidth: 200, height: 'auto' }} alt="Compositeur Digital UX" />
            </a>);
    }
    
}